<template>
  <div class="g-recaptcha" :data-sitekey="recaptchaKey" ref="recaptcha" />
</template>

<script>
import { request } from "@/lib/http";

export default {
  components: {},

  props: {},

  data() {
    return {
      recaptchaKey: process.env.VUE_APP_RECAPTCHA_KEY,
    };
  },

  methods: {
    loadRecaptcha() {
      if (typeof grecaptcha !== "undefined") {
        grecaptcha.ready(() => {
          this.setupRecaptcha();
        });
      } else {
        const script = document.createElement("script");
        script.src = `https://www.google.com/recaptcha/api.js?render=explicit`;
        script.onload = () => {
          grecaptcha.ready(() => {
            this.setupRecaptcha();
          });
        };
        document.head.appendChild(script);
      }
    },

    setupRecaptcha() {
      this.recaptcha = grecaptcha.render(this.$refs.recaptcha, {
        sitekey: this.recaptchaKey,
        callback: this.onRecaptchaChange,
      });
    },

    onRecaptchaChange(response) {
      response && this.validRecaptchaToken(response);
    },

    async validRecaptchaToken(recaptchaToken) {
      try {
        const isValid = await request({
          url: `valid-code-form-request`,
          method: "post",
          data: {
            recaptchaToken,
          },
        });

        this.$emit("recaptcha-is-valid", isValid);
      } catch (error) {
        this.$emit("recaptcha-is-valid", false);

        this.$store.dispatch("notify/error", {
          message: "Erro ao validar recaptcha",
        });
      }
    },
  },

  mounted() {
    this.loadRecaptcha();
  },
};
</script>
